import { VersionedTransaction, SystemProgram, Keypair, PublicKey, TransactionMessage, Connection } from "@solana/web3.js";
import bs58 from "bs58";
import { getSolanaRpcUrl } from "./solanaRpc";

const JITO_TIP_ACCOUNTS = [
  "96gYZGLnJYVFmbjzopPSU6QiCRK2U2EYX1rG9mP4w9a4",
  "HFqU5x63VTQVPeGvvkF5K9jA2zM8Gk1vYfG3XU4pX3GZ",
  "Cw8CFyM9FkoMi7K44r9tQ3r3A1zR6mRpt13511G8hW6x",
  "ADaUMid9yfUytqMBgopwjb4EzbX5Rbbm6tN23oN4r57w",
  "DfXygSm4jMy48uS14Jm27F1gM4K6K4rY3Ww958X5hQzX",
  "3AVi9Tg9UoG1Q5u1rD39Yp4pG2u1N6B2V1U1H7U4PzYf",
  "ojH4r6yU2qWq3fU2G7P4wG1zV6G4V8pW3w4U7q2w9U6",
  "C7xU1U9YqW1p5vX4p8wT2gV2sW5R2wU4G4U2R2P2pT2",
];

function getRandomTipAccount(): PublicKey {
  const index = Math.floor(Math.random() * JITO_TIP_ACCOUNTS.length);
  return new PublicKey(JITO_TIP_ACCOUNTS[index]);
}

export async function sendJitoBundle(
  transactions: VersionedTransaction[],
  feePayer: Keypair,
  tipLamports: number = 1000000 // 0.001 SOL
): Promise<string | null> {
  if (transactions.length === 0) return null;

  try {
    const connection = new Connection(getSolanaRpcUrl());
    const { blockhash } = await connection.getLatestBlockhash();

    // Create the tip transaction
    const tipIx = SystemProgram.transfer({
      fromPubkey: feePayer.publicKey,
      toPubkey: getRandomTipAccount(),
      lamports: tipLamports,
    });

    const tipMessage = new TransactionMessage({
      payerKey: feePayer.publicKey,
      recentBlockhash: blockhash,
      instructions: [tipIx],
    }).compileToV0Message();

    const tipTx = new VersionedTransaction(tipMessage);
    tipTx.sign([feePayer]);

    // Append tip transaction to the end of the bundle
    const bundleTxns = [...transactions, tipTx];
    const encodedTxns = bundleTxns.map((tx) => bs58.encode(tx.serialize()));

    const payload = {
      jsonrpc: "2.0",
      id: 1,
      method: "sendBundle",
      params: [encodedTxns, { encoding: "base58" }],
    };

    const res = await fetch("https://mainnet.block-engine.jito.wtf/api/v1/bundles", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const json = await res.json();
    if (json.result) {
      console.log("Jito Bundle Sent! ID:", json.result);
      return json.result;
    }
    
    console.error("Jito Bundle Error:", json.error);
    return null;
  } catch (err) {
    console.error("Failed to construct/send Jito bundle:", err);
    return null;
  }
}
